<div class="ctc-wrap">

  @if (loading) {
    <div class="ctc-skeleton">
      <div class="ctc-sk-title"></div>
      @for (_ of [1,2,3,4,5,6]; track $index) { <div class="ctc-sk-row"></div> }
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="ctc-header">
      <span class="ctc-title">Confianza por objeto detectado</span>
      <span class="ctc-count">{{ displayRows.length }} objetos únicos</span>
    </div>

    <!-- Controles -->
    <div class="ctc-toolbar">
      <!-- Tag filter -->
      <div class="ctc-tag-bar">
        @for (t of tags; track t.key) {
          <button type="button" class="ctc-tag-btn"
                  [class.is-active]="activeTag === t.key"
                  [style.--tc]="t.color"
                  (click)="setTag(t.key)">
            {{ t.label }}
          </button>
        }
      </div>
      <!-- Others toggle -->
      <button type="button" class="ctc-others-btn"
              [class.is-active]="showOthers"
              (click)="toggleOthers()">
        <i class="pi" [class.pi-eye]="!showOthers" [class.pi-eye-slash]="showOthers"></i>
        {{ showOthers ? 'Ocultar Others' : 'Mostrar Others' }}
      </button>
    </div>

    <!-- Tabla -->
    <div class="ctc-table-wrap">
      <table class="ctc-table">
        <thead>
          <tr>
            <th class="ctc-th ctc-th--name" (click)="setSort('name')">
              Objeto <i class="pi {{ sortIcon('name') }}"></i>
            </th>
            <th class="ctc-th">Tag</th>
            <th class="ctc-th ctc-th--sort" (click)="setSort('count')">
              Detecciones <i class="pi {{ sortIcon('count') }}"></i>
            </th>
            <th class="ctc-th ctc-th--sort" (click)="setSort('avgScore')">
              Score prom. <i class="pi {{ sortIcon('avgScore') }}"></i>
            </th>
            <th class="ctc-th">Min / Max</th>
            <th class="ctc-th ctc-th--sort" (click)="setSort('highConf')">
              Alta conf. ≥90% <i class="pi {{ sortIcon('highConf') }}"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          @if (displayRows.length === 0) {
            <tr><td colspan="6" class="ctc-empty">Sin datos para este filtro.</td></tr>
          }
          @for (row of displayRows; track trackByName($index, row)) {
            <tr class="ctc-tr" [class.ctc-tr--others]="row.isOthers">
              <!-- Nombre -->
              <td class="ctc-td ctc-td--name" [title]="row.name">{{ row.name }}</td>
              <!-- Tag -->
              <td class="ctc-td">
                <span class="ctc-tag-pill"
                      [style.background]="row.tagBg"
                      [style.color]="row.tagColor">
                  {{ row.tagLabel }}
                </span>
              </td>
              <!-- Detecciones -->
              <td class="ctc-td ctc-td--num">{{ row.count | number }}</td>
              <!-- Score con barra -->
              <td class="ctc-td ctc-td--score">
                <div class="ctc-score-cell">
                  <div class="ctc-score-bar">
                    <div class="ctc-score-bar__fill"
                         [style.width.%]="row.scoreBarW"
                         [style.background]="row.scoreColor">
                    </div>
                  </div>
                  <span [style.color]="row.scoreColor">{{ pct(row.avgScore) }}</span>
                </div>
              </td>
              <!-- Min / Max -->
              <td class="ctc-td ctc-td--range">
                <span class="ctc-range-min">{{ pct(row.minScore) }}</span>
                <span class="ctc-range-sep">–</span>
                <span class="ctc-range-max">{{ pct(row.maxScore) }}</span>
              </td>
              <!-- Alta confianza -->
              <td class="ctc-td ctc-td--num">
                <span [class.ctc-high]="row.highConf === row.count">
                  {{ row.highConf | number }}
                </span>
                <small class="ctc-sub">
                  ({{ (row.highConf / row.count * 100).toFixed(0) }}%)
                </small>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  }

</div>
